var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media-preview"},[_c('div',{staticClass:"media-preview__thumb"},[_vm._t("media-preview__content")],2),_vm._v(" "),_c('div',{staticClass:"media-preview__body"},[_vm._t("media-preview__name"),_vm._v(" "),_vm._t("media-preview__size")],2),_vm._v(" "),_c('ar-icon-button',{staticClass:"media-preview__discard",attrs:{"icon-props":{
      name: 'discard',
      height: '14px',
    }},on:{"click":_vm.handleDelete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }